// extracted by mini-css-extract-plugin
module.exports = {"card-not-found-block":"DigitalChannelsBlock_card-not-found-block__sPVjU","land-registration-guide":"DigitalChannelsBlock_land-registration-guide__vNJ7x"};